var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarosuleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.627 1.09595H2.62695C2.07467 1.09595 1.62695 1.54366 1.62695 2.09595V14.0959C1.62695 14.6482 2.07467 15.0959 2.62695 15.0959H14.627C15.1792 15.0959 15.627 14.6482 15.627 14.0959V2.09595C15.627 1.54366 15.1792 1.09595 14.627 1.09595ZM2.62695 0.0959473C1.52238 0.0959473 0.626953 0.991378 0.626953 2.09595V14.0959C0.626953 15.2005 1.52238 16.0959 2.62695 16.0959H14.627C15.7315 16.0959 16.627 15.2005 16.627 14.0959V2.09595C16.627 0.991378 15.7315 0.0959473 14.627 0.0959473H2.62695Z",
    fill: "#954386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62695 8.09595C4.62695 8.37209 4.85081 8.59595 5.12695 8.59595H10.9198L8.7734 10.7424C8.57814 10.9377 8.57814 11.2542 8.7734 11.4495C8.96866 11.6448 9.28524 11.6448 9.48051 11.4495L12.4805 8.4495C12.6758 8.25424 12.6758 7.93766 12.4805 7.74239L9.48051 4.74239C9.28524 4.54713 8.96866 4.54713 8.7734 4.74239C8.57814 4.93766 8.57814 5.25424 8.7734 5.4495L10.9198 7.59595H5.12695C4.85081 7.59595 4.62695 7.81981 4.62695 8.09595Z",
    fill: "#954386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarosuleRight);
export default __webpack_public_path__ + "static/media/Carosule_Right.2fcd660969dc505f73e4980f2f0c4f03.svg";
export { ForwardRef as ReactComponent };